module.exports = __webpack_public_path__ + "components/MapControl/svg/Dworzec_stacja kolejowa.svg?9585003c";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Dworzec_stacja kolejowa.svg
// module id = 2028
// module chunks = 0